import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from '../../api/axios';
import { formatDate } from "../../helpers/utils";
import LoadingModal from "../LoadingModal";
import { Link } from "react-router-dom";
import styles from './Admin.module.css';

const cloneOptions = (options) => {
	const clone = [];
	for (let option of options) {
		clone.push({ ...option });
	}
	return clone;
}
function includes(questionsInSurvey, questionId) {
	for (let question of questionsInSurvey) {
		if (question.questionId === questionId) {
			return true;
		}
	}
	return false;
}
const EditSurveyQuestions = () => {

	let { surveyId } = useParams();

	const [title, setTitle] = useState("");
	const [questionsInSurvey, setQuestionsInSurvey] = useState([]);
	const [allQuestions, setAllQuestions] = useState([]);
	const [isChecked, setIsChecked] = useState({});
	const [dateFilter, setDateFilter] = useState("week");
	const [dateCutoff, setDateCutoff] = useState();
	const [typeFilter, setTypeFilter] = useState("any");
	const [statusFilter, setStatusFilter] = useState("any");
	const [isSaving, setIsSaving] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(false);

	// const axiosPrivate = useAxiosPrivate();
	// const navigate = useNavigate();
	// const location = useLocation();

	const onCheckboxChange = (questionId, checked) => {
		const newIsChecked = { ...isChecked };
		if (!checked) {
			delete newIsChecked[questionId];
		} else {
			newIsChecked[questionId] = true;
		}
		setIsChecked(newIsChecked);
	}
	const onDateFilterChange = (value) => {
		console.log(value);
		setDateFilter(value);
	}


	const saveChanges = async () => {

		const surveyQuestionsToDelete = [];
		const surveyQuestionsToInsert = [];
		const surveyQuestionsToUpdate = [];

		let
			displayOrder = 0;

		for (let question of questionsInSurvey) {
			// console.log(`questionId: ${question.questionId} checked: ${isChecked[question.questionId]}`);
			if (isChecked[question.questionId]) {
				displayOrder++;
				if (question.displayOrder !== displayOrder) {
					surveyQuestionsToUpdate.push({ ...question, displayOrder: displayOrder });
					// console.log("Updated");
				} else {
					// console.log("Ignored");
				}
			} else {
				surveyQuestionsToDelete.push({
					surveyQuestionId: question.surveyQuestionId
				});
				// console.log("Deleted");
			}
		};

		for (let questionId in isChecked) {
			// console.log(`questionId: ${questionId} checked: ${isChecked[questionId]} includes: ${includes(questionsInSurvey, questionId)}`);
			questionId = parseInt(questionId, 10);
			if (!includes(questionsInSurvey, questionId)) {
				displayOrder++;
				surveyQuestionsToInsert.push({
					questionId: questionId,
					displayOrder: displayOrder
				})
			}
		};

		const json = {};

		json.surveyQuestionsToDelete = cloneOptions(surveyQuestionsToDelete);
		json.surveyQuestionsToUpdate = cloneOptions(surveyQuestionsToUpdate);
		json.surveyQuestionsToInsert = cloneOptions(surveyQuestionsToInsert);

		console.log(json);

		if (
			(surveyQuestionsToDelete.length > 0) ||
			(surveyQuestionsToUpdate.length > 0) ||
			(surveyQuestionsToInsert.length > 0)
		) {
			setIsSaving(true);
			try {
				const response = await axios.patch(`/surveys/${surveyId}`,
					JSON.stringify(json),
					{
						headers: { 'Content-Type': 'application/json' }
					}
				);
				console.log(JSON.stringify(response?.data));

				setTitle(response.data.title);
				setQuestionsInSurvey(cloneOptions(response.data.surveyQuestions));
				setIsSaving(false);

				// setAllQuestions(cloneOptions(response.data.allQuestions));

			} catch (err) {
				console.log(err);
				// if (!err?.response) {
				//     setErrMsg('No Server Response');
				// } else if (err.response?.status === 409) {
				//     setErrMsg('Email Taken');
				// } else {
				//     setErrMsg('Registration Failed')
				// }
				// errRef.current.focus();
			}

		}

	}

	useEffect(() => {
		let checked = {};
		for (let question of questionsInSurvey) {
			checked[question.questionId] = true;
		}
		setIsChecked(checked);
	}, [questionsInSurvey]);

	useEffect(() => {
		const today = new Date();
		let cutoff;
		switch (dateFilter) {
			case "day":
				cutoff = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
				break;
			case "week":
				cutoff = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
				break;
			case "month":
				cutoff = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
				break;
			case "year":
				cutoff = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
				break;
			default:
				cutoff = new Date(2000, today.getMonth(), today.getDate() - 1);
		}
		setDateCutoff(cutoff);
	}, [dateFilter]);

	useEffect(() => {

		if (surveyId === undefined) {
			return;
		}

		let isMounted = true;

		const controller = new AbortController();

		const getSurvey = async () => {

			setIsSaving(true);

			try {
				const response = await axios.get(`/surveys/${surveyId}/questions`, {
					signal: controller.signal
				});
				console.log(response.data);
				if (isMounted) {
					setTitle(response.data.title);
					setQuestionsInSurvey(cloneOptions(response.data.surveyQuestions));
					setAllQuestions(cloneOptions(response.data.allQuestions));
					setIsSaving(false);
					setDataLoaded(true);
				}
			} catch (err) {
				if (isMounted) {
					console.error(err);
					// if (err.response?.status === 403) {
					//     navigate('/login', { state: { from: location }, replace: true });
					// }
				}
			}
		}

		getSurvey();

		return () => {
			isMounted = false;
			controller.abort();
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (!dataLoaded) {
        return <LoadingModal />;
    }

    console.log(`EditSurveyQuestions: render at ${new Date().getTime()}`);

	return (
		<section className={styles.admin} style={{maxWidth: "none"}}>
			<p><Link to="/admin">Admin</Link> &gt; <Link to="/surveys">Surveys</Link> &gt; <Link to={`/survey/edit/${surveyId}`}>{title}</Link></p>
			<h3>Select questions to add to survey</h3>
			<div className="filters">
				<div className="labelAndSelectContainer">
					<label htmlFor="dateFilter">Edited:</label>
					<select id="dateFilter" value={dateFilter} onChange={(e) => onDateFilterChange(e.target.value)}>
						<option value="day">Within the last day</option>
						<option value="week">Within the last week</option>
						<option value="month">Within the last month</option>
						<option value="year">Within the last year</option>
						<option value="any">Any time</option>
					</select>
				</div>
				<div className="labelAndSelectContainer">
					<label htmlFor="typeFilter">Type:</label>
					<select id="typeFilter" value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
						<option value="text">Text</option>
						<option value="numeric">Numeric</option>
						<option value="multiple choice">Multiple choice</option>
						<option value="matrix">Matrix</option>
						<option value="constant sum">Constant sum</option>
						<option value="any">Any</option>
					</select>
				</div>
				<div className="labelAndSelectContainer">
					<label htmlFor="statusFilter">Status:</label>
					<select id="statusFilter" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
						<option value="active">Active</option>
						<option value="archived">Archived</option>
						<option value="any">Any</option>
					</select>
				</div>
			</div>

			<table className="standard">
				<thead>
					<tr>
						<th>&nbsp;</th>
						<th>Question</th>
						<th>Type</th>
						<th>Status</th>
						<th>Edited</th>
					</tr>
				</thead>
				<tbody>
					{
						allQuestions.map((question, i) => {
							let checked = isChecked[question.questionId] === true ? true : false;
							const date = new Date(Date.parse(question.lastModified));
							const passDateFilter = date >= dateCutoff;
							const passTypeFilter = ((question.type === typeFilter) || (typeFilter === "any"));
							const passStatusFilter = ((question.status === statusFilter) || (statusFilter === "any"));
							if (passDateFilter && passTypeFilter && passStatusFilter) {
								return (
									<tr key={i}>
										<td><input type="checkbox" id={question.questionId} name={question.questionId} value={question.questionId} checked={checked} onChange={(e) => onCheckboxChange(question.questionId, e.target.checked)} /></td>
										<td>{question.text}</td>
										<td>{question.type}</td>
										<td>{question.status}</td>
										<td>{formatDate(date)}</td>
									</tr>
								)
							} else {
								return null;
							}
						})
					}

				</tbody>

			</table>

			<button disabled={isSaving} onClick={saveChanges}>Save changes</button>

		</section>
	);

};

export default EditSurveyQuestions;